// extracted by mini-css-extract-plugin
export default {"list":"SmartTagsTextInput_list__QMKf9","suggestionsList":"SmartTagsTextInput_suggestionsList__zesQO","insertedTag":"SmartTagsTextInput_insertedTag__mxHid"};